"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
var _APNumberInput = _interopRequireDefault(require("../common/APNumberInput"));
var _APSelect = _interopRequireDefault(require("../common/APSelect"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _APCheckbox = _interopRequireDefault(require("../common/APCheckbox"));
var _instrumentPropTypes = require("../../propTypes/instrumentPropTypes");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _commonComponent = require("../../propTypes/commonComponent");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _orderHelper = require("../../helpers/orderHelper");
var _UserBalanceComponent = _interopRequireDefault(require("../UserBalance/UserBalanceComponent"));
var _APInput = _interopRequireDefault(require("../common/APInput"));
var _formValidations = require("../../helpers/formValidations");
require("./ReportBlockTradeForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)(['report-block-trade-form']);
var slidePaneClasses = (0, _cssClassesHelper.getBEMClasses)('slide-pane');
var dividerClasses = (0, _cssClassesHelper.getBEMClasses)('divider');
var ReportBlockTradeForm = function ReportBlockTradeForm(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var position1 = props.position1,
    position2 = props.position2,
    instruments = props.instruments,
    handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    disableTrading = props.disableTrading,
    formObj = props.formObj,
    decimalPlaces = props.decimalPlaces,
    selectedInstrument = props.selectedInstrument,
    invalid = props.invalid,
    products = props.products,
    VerificationRequiredComponent = props.VerificationRequiredComponent,
    showLockedIn = props.showLockedIn,
    orderTotal = props.orderTotal,
    orderNet = props.orderNet,
    useNewForm = props.useNewForm;
  var boughtProductSymbol = selectedInstrument.Product1Symbol;
  var soldProductSymbol = selectedInstrument.Product2Symbol;
  return /*#__PURE__*/_react["default"].createElement("form", {
    className: slidePaneClasses('body'),
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('main-section')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('inputs-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(null, ['with-padding'])
  }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "instrument",
    label: "".concat(t('Instrument'), ":"),
    customClass: bemClasses(),
    options: instruments.map(function (instrument) {
      var InstrumentId = instrument.InstrumentId;
      return {
        value: InstrumentId,
        label: instrument.Symbol
      };
    }),
    showTriangles: true
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('counterparty')
  }, /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
    name: "counterparty",
    label: "".concat(t('Counterparty'), ":"),
    customClass: bemClasses()
  }), showLockedIn && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('checkbox-container')
  }, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
    name: "lockedIn",
    type: "checkbox",
    id: "locked-in",
    label: t('Locked In')
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('inputs-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(null, ['with-padding'])
  }, /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
    name: "quantity",
    placeholder: "0",
    label: "".concat(t(useNewForm ? 'Quantity' : 'Product Bought'), ":"),
    decimalPlaces: decimalPlaces[boughtProductSymbol],
    customClass: bemClasses(),
    labelInInput: boughtProductSymbol,
    validate: [_formValidations.greaterThanZero]
  })), /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
    name: "price",
    placeholder: "0",
    label: "".concat(t(useNewForm ? 'Price' : 'Product Sold'), ":"),
    decimalPlaces: decimalPlaces[soldProductSymbol],
    customClass: bemClasses(),
    labelInInput: soldProductSymbol,
    validate: [_formValidations.greaterThanZero]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(null, 'with-small-padding')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(t('Fees'), ":"),
    text: (0, _orderHelper.getOrderFee)(formObj.values, products),
    customClass: bemClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(null, 'with-small-padding')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(t('Received'), ":"),
    text: orderNet,
    customClass: bemClasses()
  })), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(t('Order Total'), ":"),
    text: orderTotal,
    customClass: bemClasses()
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('user-balance-container')
  }, /*#__PURE__*/_react["default"].createElement(_UserBalanceComponent["default"], {
    position1: position1,
    position2: position2
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "submit",
    disabled: submitting || invalid || disableTrading,
    customClass: bemClasses(),
    styleName: formObj.values.side === _orderEntryFormConstants.sellValue ? _commonComponent.styleNames.subtractive : _commonComponent.styleNames.additive
  }, submitting ? t('Processing...') : t('Submit Report'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('verification-required')
  }, VerificationRequiredComponent));
};
ReportBlockTradeForm.defaultProps = {
  showLockedIn: true
};
ReportBlockTradeForm.propTypes = {
  handleSubmit: _propTypes["default"].func.isRequired,
  position1: _propTypes["default"].object.isRequired,
  position2: _propTypes["default"].object.isRequired,
  instruments: _propTypes["default"].arrayOf(_instrumentPropTypes.instrumentPropType).isRequired,
  formObj: _propTypes["default"].object,
  submitting: _propTypes["default"].bool.isRequired,
  VerificationRequiredComponent: _propTypes["default"].element,
  disableTrading: _propTypes["default"].bool.isRequired,
  showLockedIn: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = ReportBlockTradeForm;